import React, {useCallback, useContext, useEffect, useState} from 'react';
import {Button, setOptions, toast} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import './styles/header.css';
import English from "./locale/english.json";
import Spanish from "./locale/spanish.json";
import Empty from "./utils/Empty";
import HeaderAccount from "./dialogs/HeaderAccount";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLanguage} from "@fortawesome/pro-duotone-svg-icons";
import {NetworkContext} from "./utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function Header({Dialog, dialog, configuration, locale, select, setLocale, width, micro, setConfiguration, account, wss, setDialog, setNavigation, setMicroApp, setMicro}) {
    const {restCall, restResponse, setRestResponse} = useContext(NetworkContext);
    const [iconHover, setIconHover] = useState(null);

    const Configuration = data => {
        const message = {
            type: 'rest',
            path: 'account-configuration',
            action: 'get',
            data: {
                account: data
            }
        };
        restCall(message);
    }

    const ShortenerMicro = () => {
        const message = {
            type: 'rest',
            path: 'shortener-micro',
            action: 'get',
            data: {
                micro: micro
            }
        };
        restCall(message);
    }

    const ButtonLocale = () => {
        if (window.localStorage.locale === 'en') {
            window.localStorage.locale = 'es';
            setLocale(Spanish);
        } else if (window.localStorage.locale === 'es') {
            window.localStorage.locale = 'en';
            setLocale(English);
        }
    }

    const GetAccountConfiguration = useCallback(data => {
        if (data.configuration) {
            let item = {...data.configuration};
            item.locale.es = Object.assign(item.locale.es, Spanish);
            item.locale.en = Object.assign(item.locale.en, English);
            setConfiguration(item);
            if (window.localStorage.locale && window.localStorage.locale === 'en') {
                setLocale(item.locale.en);
            } else if (window.localStorage.locale && window.localStorage.locale === 'es') {
                setLocale(item.locale.es);
            }
            select.current = false;
        }
        if (data.account) {
            account.current = data.account;
            window.localStorage.account = data.account;
        }
        if (data.url) {
            wss.current = data.url;
        }
        if (data.dialog) {
            setDialog(data.dialog);
        }
        if (data.navigation) {
            setNavigation(data.navigation);
        }
        if (data.error) {
            toast({message: locale.header.c, color: 'danger', duration: 3000, display: 'bottom'});
        }
    }, [locale.header.c]);

    const GetShortenerMicro = useCallback(data => {
        if (data.microApp) {
            setNavigation(data.microApp.navigation);
            delete data.microApp.navigation;
            setDialog(data.microApp.dialog);
            delete data.microApp.dialog;
            let item = {...data.microApp};
            item.locale.es = Object.assign(item.locale.es, Spanish);
            item.locale.en = Object.assign(item.locale.en, English);
            setMicroApp(item);
            if (window.localStorage.locale && window.localStorage.locale === 'en') {
                setLocale(item.locale.en);
            } else if (window.localStorage.locale && window.localStorage.locale === 'es') {
                setLocale(item.locale.es);
            }
        }
        if (data.error) {
            toast({message: locale.header.d, color: 'danger', duration: false, display: 'center'});
        }
        setMicro(null);
    }, [locale.header.d]);

    useEffect(() => {
        if (restResponse && !Empty(restResponse) && restResponse.action === 'get' && restResponse.path === 'account-configuration') {
            GetAccountConfiguration(restResponse.data);
            setRestResponse({});
        }
    }, [restResponse, GetAccountConfiguration, setRestResponse]);

    useEffect(() => {
        if (restResponse && !Empty(restResponse) && restResponse.action === 'get' && restResponse.path === 'shortener-micro') {
            GetShortenerMicro(restResponse.data);
            setRestResponse({});
        }
    }, [restResponse, GetShortenerMicro, setRestResponse]);

    useEffect(() => {
        if (micro) {
            ShortenerMicro();
        } else if (!account.current && !micro) {
            Dialog({view: 'headerAccount'});
        } else if (account.current && !micro) {
            Configuration(account.current);
        }
    }, []);

    return (
        <div className="mbsc-grid cs-header-toolbar">
            <div className="mbsc-row">
                <div className="mbsc-col">
                    <div className="mbsc-row cs-header-col-start">
                        <div className="cs-header-logo" style={{backgroundImage: `url(${configuration.logo})`}} />
                        <Button onClick={() => Dialog({view: 'headerAccount'})} color="primary" className="cs-header-button mbsc-bold" variant="flat" >
                            {configuration.displayName}
                        </Button>
                    </div>
                </div>
                <div className="mbsc-col-auto">
                    <div className="mbsc-row cs-header-col-end">
                        <Button onMouseEnter={() => setIconHover('language')} onMouseLeave={() => setIconHover(null)} onClick={() => ButtonLocale()} className="cs-header-button mbsc-bold" variant="flat" >
                            <FontAwesomeIcon className="cs-header-icon" icon={faLanguage} beatFade={iconHover === 'language'} /> {locale.header.a + (width > 576 ? locale.header.b : '')}
                        </Button>
                    </div>
                </div>
            </div>
            {dialog.view === 'headerAccount' &&
                <HeaderAccount
                    locale={locale}
                    dialog={dialog}
                    Dialog={Dialog}
                    select={select.current}
                    width={width}
                />
            }
        </div>
    );
}

export default Header;
